module.exports = __webpack_public_path__ + "img/default-l-8dc114.67ebda2f.svg";